import script from "./contedo-integraes.vue?vue&type=script&setup=true&lang=js"
export * from "./contedo-integraes.vue?vue&type=script&setup=true&lang=js"

import "./contedo-integraes.vue?vue&type=style&index=0&id=06737800&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06737800"]])

export default __exports__